import {
  Equal3ow85705ftxfk as Equal,
  NotInside2db9qer39ktxf as NotInside,
  LessThanOrEqual3qv1kgxmn1wy as LessThanOrEqual,
  NotEqual12qw5zp9xbgnd as NotEqual,
  Inside39cktoz42t35z as Inside,
  GreaterThanOrEqualhh0t265tpr4s as GreaterThanOrEqual,
  StringContains38lplog8dg7er as StringContains,
  Never_getInstance32s86skpi7zck as Never_getInstance,
  Always_getInstancecs10mhg5aot2 as Always_getInstance,
} from './Condition.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { StringArrayFormat41o1nrt6c6ex as StringArrayFormat } from '../lightningserver/StringArrayFormat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var f;
function eq(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(Equal().c3r(value));
}
function xDataClassPathNotInSet(_this__u8e3s4, values) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(NotInside().i3r(toList(values)));
}
function lte(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(LessThanOrEqual().r3r(value));
}
function neq(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(NotEqual().e3r(value));
}
function inside(_this__u8e3s4, values) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(Inside().g3r(values));
}
function xDataClassPathInsideSet(_this__u8e3s4, values) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(Inside().g3r(toList(values)));
}
function gte(_this__u8e3s4, value) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(GreaterThanOrEqual().p3r(value));
}
function xDataClassPathContainsCased(_this__u8e3s4, value, ignoreCase) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return _this__u8e3s4.k3t(StringContains().s3r(value, ignoreCase));
}
function condition(boolean) {
  _init_properties_ConditionBuilder_kt__m7iuao();
  return boolean ? Always_getInstance() : Never_getInstance();
}
var properties_initialized_ConditionBuilder_kt_oyhlmm;
function _init_properties_ConditionBuilder_kt__m7iuao() {
  if (!properties_initialized_ConditionBuilder_kt_oyhlmm) {
    properties_initialized_ConditionBuilder_kt_oyhlmm = true;
    f = new (StringArrayFormat())(EmptySerializersModule());
  }
}
//region block: exports
export {
  condition as conditionyulnlu9fimag,
  xDataClassPathContainsCased as xDataClassPathContainsCased3idu6cb2g32wr,
  eq as eq1298m2cje971u,
  gte as gte30bher1s1u7hr,
  xDataClassPathInsideSet as xDataClassPathInsideSet1u5agsol0s6ul,
  inside as inside3oxyfk5qky4sm,
  lte as lte255n7t6e9er47,
  neq as neqqjkp0prqcfuy,
  xDataClassPathNotInSet as xDataClassPathNotInSet2lprzz67ddi7c,
};
//endregion

//# sourceMappingURL=ConditionBuilder.mjs.map
